<template>
  
  <div class="chartTempoRecarga">
      <div class="chartItemTitulo">Tempo Estimado para Recarga</div>
    <div class="chartItemIcone" id="iconeRecargachart">
      <i class="fas fa-charging-station"></i>
    </div>
    <div class="chartItemValor" id="valorRecargachart">0 minutos </div>
  </div>

</template>

<script>

export default {
    name: 'ChartTempoRecarga'
}
</script>

<style>
.chartTempoRecarga {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
#iconeRecargachart {
  color: red;
}
#valorRecargachart {
  margin-top: 21.5px;
}
</style>